import React, { useEffect, useState } from 'react';
import { Modal, Box, Typography, Button } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import { useHistory, useLocation } from 'react-router-dom';
import styles from './index.module.css'; 
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';

const PaymentSuccessModal = () => {
  const [open, setOpen] = useState(false);
  const history = useHistory();
  const location = useLocation();
  const { instanceUniqueId,orderId } = useParams();
  const previousPath = location.pathname;
  console.log(previousPath,"PREVIOUS PATH")
    const path = `/instance/${instanceUniqueId}/sales/orders/${orderId}`;

  const isPaymentFailed = previousPath?.includes('payment-failed');
  const isPaymentSuccess = previousPath?.includes('payment-success');

  useEffect(() => {
    if (isPaymentSuccess || isPaymentFailed) {
      setOpen(true);
      setTimeout(() => {
        setOpen(false);
   history.push(`${path}/invoice`);
      }, 5000);
    }
  }, []);

  const handleClose = () => {
    setOpen(false);
   history.push(`${path}/invoice`);
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          backgroundColor: '#fff',
          boxShadow: 24,
          p: 4,
          width: 400,
          textAlign: 'center',
          borderRadius: 2,
        }}
      >
        {isPaymentSuccess && (
          <CheckCircleIcon className={styles.checkmark} style={{ color: 'green', fontSize: 60 }} />
        )}
        {isPaymentFailed && (
          <ErrorIcon className={styles.checkmark} style={{ color: 'red', fontSize: 60 }} />
        )}
        <Typography variant="h5" fontWeight="bold" gutterBottom>
          {isPaymentSuccess ? 'Your payment was successful' : 'Payment failed'}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {isPaymentSuccess
            ? 'Thank you for your payment. We will \nbe in contact with more details shortly.'
            : 'Your transaction could not be completed. Please try again or contact support.'}
        </Typography>
        <Button
          variant="contained"
          color={isPaymentSuccess ? 'success' : 'error'}
          sx={{ mt: 3 }}
          onClick={handleClose}
        >
          Close
        </Button>
      </Box>
    </Modal>
  );
};

export default PaymentSuccessModal;
